// extracted by mini-css-extract-plugin
module.exports = {"nearby__item":"NearbyItems_nearby__item__3Q69Y"};